import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-update-group-filter',
  templateUrl: './update-group-filter.component.html',
  styleUrls: ['./update-group-filter.component.scss'],
})
export class UpdateGroupFilterComponent  implements OnInit {

  breadcrumbList = [
    {
      label: 'Group filters',
      embedurl: true,
      url: '/baseapp/user-group'
    },
    {
      label: 'Update filter',
      embedurl: false,
      url: ''
    }
  ];
  updateGroupFilterForm: UntypedFormGroup;
  // submitted: boolean = false;
  hide: boolean = true;
  hide1200: boolean = false;
  userIp;
  conditionList = [
    { label: 'is equal', value: '1' },
    { label: 'is not equal', value: '0' }
  ];
  selectedCondition = [];
  //dataTypeList = ['Long', 'Text', 'Date', 'Binary', 'Vector'];
  dataTypeList: any
  selectedDataType = 'Long';
  filterId: any;
  groupId: any;
  getGroupFilterApi: Subscription | undefined;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    private route: ActivatedRoute,
    public storage: Storage,
    private location: Location,
    public helperService: HelperService) { }

  ngOnInit() {
    const queryParams = this.route.snapshot.paramMap;
    this.filterId = queryParams.get('id');
    this.updateGroupFilterForm = this.formBuilder.group({
      'indexName': ['', [Validators.required,this.checkIndexNameFormat()]],
      'columnName': ['', [Validators.required]],
      'conditionFlag': [[], Validators.required],
      'columnValue': ['', [Validators.required]],
      'columnDataType': [[], Validators.required]
    });

    this.updateGroupFilterForm.get('columnDataType')?.valueChanges.subscribe((dataType) => {
      this.applyColumnValueValidation(dataType);
    });
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });

    this.getUserIp();
    this.generatetoken();
    this.getGroupFilters(this.filterId);
  }
   
  private checkIndexNameFormat(): ValidatorFn {
    const noWhiteSpace = /\s/;  // Detect whitespace
    const invalidCharacters = /[^a-zA-Z0-9_-]/; // Allow only alphanumeric, underscore (_), and hyphen (-)
  
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value;
      if (val) {
        if (noWhiteSpace.test(val)) {
          return { noSpace: true };  // Error for whitespace
        }
        if (invalidCharacters.test(val)) {  
          return { invalidCharacters: true };  // Error for other special characters
        }
      }
      return null;
    };
  }

  private applyColumnValueValidation(dataType: string) {
    const columnValueControl = this.updateGroupFilterForm.get('columnValue');
    if (!columnValueControl) return;
  
    // Clear existing validators
    columnValueControl.clearValidators();
    let validators = [Validators.required];
  
    if (dataType === 'Text') {
      validators.push(Validators.maxLength(65535)); // Allows large text (adjust if needed)
    } else if (dataType === 'Long') {
      validators.push(Validators.pattern(/^-?[0-9]{1,19}$/)); // 64-bit signed integer range
    } else if (dataType === 'Date') {
      validators.push(this.validateISODateTimeFormat());
    } else if (dataType === 'Binary') {
      validators.push(this.validateBase64Binary());
    } else if (dataType === 'Vector') {
      validators.push(this.validateKnnVector());
    }  else if (dataType === 'Float') {
      validators.push(this.validateFloat());
    } else if (dataType === 'Double') {
      validators.push(this.validateDouble());
    } else if (dataType === 'Integer') {
      validators.push(this.validateInteger());
    } else if (dataType === 'Short Integer') {
      validators.push(this.validateShortInteger());
    } else if (dataType === 'Byte') {
      validators.push(this.validateByte());
    }
  
    // Apply updated validators
    columnValueControl.setValidators(validators);
    columnValueControl.updateValueAndValidity();
  }
   // Custom validator for ISO 8601 Date-Time format (YYYY-MM-DDTHH:MM:SSZ)
  
   private validateISODateTimeFormat(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value;
      return val && !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(val)
        ? { invalidISODate: true }
        : null;
    };
  }
  

    // Custom validator for Base64-encoded binary values

  private validateBase64Binary(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const val = control.value;
    
        if (!val) return null;
        const base64Pattern = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
    
        return base64Pattern.test(val) ? null : { invalidBase64: true };
      };
    }
  
  
  //  Custom validator for k-NN Vector (Array of floating-point numbers)
  
  private validateKnnVector(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value?.trim();
      const vectorPattern = /^-?\d+(\.\d+)?(,\s*-?\d+(\.\d+)?)*$/;
  
      return val && !vectorPattern.test(val)
        ? { invalidVector: true }
        : null;
    };
  }

  //  Custom validator for Float 

  private validateFloat(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
          const val = control.value;
          
          if (!val) return null; // Allow empty values (optional field)
          
          // Float regex: Allows decimals & scientific notation
          const floatPattern = /^-?\d+(\.\d+)?(e-?\d+)?$/i;
      
          return floatPattern.test(val) ? null : { invalidFloat: true };
        };
      }

  // Custom validator for Double (Double Precision Floating Point Number)
  private validateDouble(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value;
      return val && !/^-?\d+(\.\d+)?$/.test(val)
        ? { invalidDouble: true }
        : null;
    };
  }

  // Custom validator for Integer (32-bit Signed Integer)
  private validateInteger(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value;
      return val && !/^-?\d{1,10}$/.test(val)
        ? { invalidInteger: true }
        : null;
    };
  }

  // Custom validator for Short Integer (-32,768 to 32,767)
  private validateShortInteger(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value;
      return val && !/^-?(3276[0-7]|[0-9]{1,4})$/.test(val)
        ? { invalidShortInteger: true }
        : null;
    };
  }

  // Custom validator for Byte (-128 to 127)
  private validateByte(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value;
      return val && !/^-?(12[0-7]|1[01][0-9]|[0-9]{1,2})$/.test(val)
        ? { invalidByte: true }
        : null;
    };
  }





  ngAfterViewInit(): void {
    setTimeout(() => {
      this.helperService.closeLoader();
    }, 2000);
  }

  ngOnDestroy(): void {
    if (this.getGroupFilterApi) {
      this.getGroupFilterApi.unsubscribe();
    }
    this.helperService.closeLoader();
  }

  get f() { return this.updateGroupFilterForm.controls; }
  get setUserControls() { return this.updateGroupFilterForm.controls; }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  getUserIp() {
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
      })
  }

  generatetoken() {
    this.getStorage().then((res) => {
      let payload = {
        type: 'index_management',
      };
      this.backendService
        .postApiTermsCall('getApiTerms', payload, res.token)
        .subscribe(
          (data) => {
            this.getGenerateToken(
              data['data'][0].username,
              data['data'][0].hashed_password
            );
          },
          (error) => {
            //console.log(error);
          }
        );
    });
  }

  getGenerateToken(userName, password) {
    const payload = new FormData();
    payload.append('username', userName);
    payload.append('password', password);
    let python_base_url = environment.python_api_base_url + '/token';
    this.backendService
      .PostExternalTokenAPICall(python_base_url, payload)
      .subscribe(
        (data) => {
          this.storage.set('updated-token', data.access_token);
          this.dataTypeListofItem(data.access_token);
          // //console.log(data.access_token);
        },
        (error) => {
          //console.log(error);
        }
      );
  }

  dataTypeListofItem(access_token) {
    let python_base_url = environment.goldfinch_base_url + '/getIndexDatatypes';
    this.backendService
      .getExternalTokenGoldfinchAPICall(python_base_url, access_token)
      .subscribe((data) => {
        let indexDatatypes = data.data;
        this.dataTypeList = indexDatatypes.map(item => item.display_value);
      });
  }

  updateBreadcrumbUrl(): void {
    const breadcrumbUrl = '/baseapp/user-group/group-filters';
    const urlTree = this.router.createUrlTree([breadcrumbUrl, this.groupId]);
    this.breadcrumbList[0].url = urlTree.toString();
  }

  getConditionSelected(e) {
    let condition = e.value;
    this.updateGroupFilterForm.controls['conditionFlag'].setValue(condition);
    this.selectedCondition = condition;
  }

  getDataTypeSelected(e) {
    this.selectedDataType = this.updateGroupFilterForm.controls['columnDataType'].value;
    this.updateGroupFilterForm.controls['columnValue'].valueChanges.subscribe(date => {
      if (date) {
        if (this.updateGroupFilterForm.controls['columnDataType'].value === 'Date') {
          let formattedDate = new Date(date).toISOString().slice(0, -5) + "Z";
          this.updateGroupFilterForm.controls['columnValue'].setValue(formattedDate, { emitEvent: false });
          this.updateGroupFilterForm.updateValueAndValidity()
        }
      }
    });
  }

  getGroupFilters(filterId: any) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        id : filterId
      }
      this.getGroupFilterApi = this.backendService.PostAPICall('getGroupFilterById', payload, res.token).subscribe(
        data => {
          this.helperService.closeLoader();
          let res = data.data;
          this.groupId = res.group_id;
          this.updateBreadcrumbUrl();
          this.updateGroupFilterForm.patchValue(
            {
              indexName: res.index_name,
              columnName: res.column_name,
              conditionFlag: res.condition_flag,
              columnValue: res.column_value,
              columnDataType: res.column_type
            })
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  onSubmit() {
    if (this.updateGroupFilterForm.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }
    this.helperService.loader();

    this.getStorage().then((res) => {
      if(this.updateGroupFilterForm.value.columnDataType=='Vector'){
        this.updateGroupFilterForm.value.columnValue=`[${this.updateGroupFilterForm.value.columnValue}]`;
      }if(this.updateGroupFilterForm.value.columnDataType=='Boolean'){
        this.updateGroupFilterForm.value.columnValue=`${this.updateGroupFilterForm.value.columnValue}`;
      }

      let payload = {
        id             : this.filterId,
        index_name     : this.updateGroupFilterForm.value.indexName,
        column_name    : this.updateGroupFilterForm.value.columnName,
        condition_flag : this.updateGroupFilterForm.value.conditionFlag,
        column_value   : this.updateGroupFilterForm.value.columnValue,
        column_type    : this.updateGroupFilterForm.value.columnDataType
      }

      this.backendService.PutAPICall('updateGroupFilter', payload, res.token).subscribe(
        (data) => {
          this.helperService.closeLoader();
          this.helperService.presentToast(data.msg, 2000);
          this.router.navigate(['/baseapp/user-group/group-filters', this.groupId]);
        },
        (error) => {
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  goToGroupFilterList() {
    this.router.navigate(['/baseapp/user-group/group-filters', this.groupId]);
  }

  goBack() {
    this.location.back();
  }

}
